/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { uniqueId } from 'lodash';
import { FlexLayout, FlexItem } from '@waca/ca-ui-toolkit';
import stringResource from 'ba-filter-nls';

import FilterHeader from './FilterHeader';
import SummaryHelper from './SummaryHelper';

import './FilterSummary.scss';

export default class FilterSummary extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		showMenu: PropTypes.bool,
		title: PropTypes.string.isRequired,
		condition: PropTypes.object.isRequired,
		inverted: PropTypes.bool.isRequired,
		onMenu: PropTypes.func,
		readOnly: PropTypes.bool,
		hasManualSelections: PropTypes.bool,
		menuButtonPressed: PropTypes.bool,
	};

	// Define default property values
	static defaultProps = {
		showMenu: true,
		readOnly: false,
		hasManualSelections: false,
		menuButtonPressed: false,
	};

	componentWillMount() {
		this._conditionSummaryId1 = uniqueId('conditionSummary-');
		this._conditionSummaryId2 = uniqueId('conditionSummary-');
	}

	_conditionSummaryId1: string;
	_conditionSummaryId2: string;
	_filterHeader: FilterHeader;

	// Event handlers
	_onMenu = () => {
		this.props.onMenu();
	};

	focus() {
		this._filterHeader.focus();
	}

	render() {
		const {
			title,
			showMenu,
			condition,
			inverted,
			readOnly,
			hasManualSelections,
			menuButtonPressed,
		} = this.props;
		const showSearch = false;
		const showClose = false;
		const showMatch = true;
		const ids = hasManualSelections
			? `${this._conditionSummaryId1} ${this._conditionSummaryId2}`
			: this._conditionSummaryId1;

		return (
			<FlexLayout className="bi-filter-summary" direction="column">
				<FlexItem gutter={[1, 1, 0.5, 0]}>
					<FilterHeader
						ref={header => {
							this._filterHeader = header;
						}}
						title={title}
						onMenu={this._onMenu}
						showMenu={showMenu}
						menuTitle={stringResource.get('editCondition')}
						menuButtonPressed={menuButtonPressed}
						showSearch={showSearch}
						showClose={showClose}
						readOnly={readOnly}
						showMatchCondition={showMatch}
						menuButtonDescribedby={ids}
					/>
				</FlexItem>
				<FlexItem
					gutter={[0, 2, 2, 2]}
					id={this._conditionSummaryId1}
					className="bi-filter-summary-desc"
					data-tid="filterSummarySection"
				>
					{SummaryHelper.getSummary(condition, inverted)}
				</FlexItem>
				{hasManualSelections && (
					<FlexItem gutter={[0, 2, 2, 2]} id={this._conditionSummaryId2}>
						{stringResource.get('containsExcludedIncludedItems')}
					</FlexItem>
				)}
			</FlexLayout>
		);
	}
}
